<template>
  <div v-if="itemsCount > 1" class="flex gap-12">
    <!-- Borders should probably be in the DS -->
    <RevButtonIcon
      :aria-label="i18n(translations.buttonPrevious)"
      class="border-action-default-low border-1"
      :disabled="loading || currentItem === 0"
      :icon="IconChevronLeft"
      size="small"
      variant="secondary"
      @click="emit('previous')"
    />
    <RevButtonIcon
      :aria-label="i18n(translations.buttonNext)"
      class="border-action-default-low border-1"
      :disabled="loading || currentItem === itemsCount - 1"
      :icon="IconChevronRight"
      size="small"
      variant="secondary"
      @click="emit('next')"
    />
  </div>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconChevronLeft } from '@ds/icons/IconChevronLeft'
import { IconChevronRight } from '@ds/icons/IconChevronRight'

import translations from './ScrollNavigation.translations'

defineProps<{
  currentItem: number
  itemsCount: number
  loading: boolean
}>()

const emit = defineEmits(['previous', 'next'])

const i18n = useI18n()
</script>
